import { NewsMixpanelEvents } from '../../constants/mixpanel-events';
import type { ArticleReadSection } from '../trackArticleRead/trackArticleRead';
import { track } from '$global/utils/track';

// Article completion (HB-977) — the scroll signal, separate from the read-time
// milestones: the end of the article body came into view. Fired at most once
// per article; deep engagement (scroll + time) is derived downstream rather
// than tagged as a third event.
export const trackArticleCompleted = ({
	articleId,
	section,
}: {
	articleId: string;
	section: ArticleReadSection;
}) => {
	track(NewsMixpanelEvents.ArticleCompleted, {
		article_id: articleId,
		section,
		completed: true,
	});
};
